import type { GetInvoicePdfResponse } from '@vy/api-definition';
import { GetInvoicePdfResponseSchema } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../services/api';

export type DownloadInvoicePdfRequest = Parameters<WeftApi['getInvoicePdf']>[0];

export function useGetInvoicePdf(
  options?: UseMutationOptions<GetInvoicePdfResponse, unknown, DownloadInvoicePdfRequest>,
) {
  return useMutation({
    mutationFn: async (payload) => {
      const api = getPrivateApi();

      const response = await api.getInvoicePdf(payload);

      return GetInvoicePdfResponseSchema.parse(response);
    },
    ...options,
  });
}
